import * as React from "react";
import classes from "./SearchEmployee.module.css";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextField from "@mui/material/TextField";
import SearchResults from "../SearchResults/SearchResults";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "components/AccordionComponents/AccordionComponents";
import {
  getAllJobNames,
  getAllLocations,
  getParentClientDetails,
  getClientDetails,
  getProgramDetails,
  getProjectDetails,
  getAllSubSystems,
  getLogonIds,
  searchEmployees,
} from "services/centerPointUserServices";
import BackdropComponent from "components/Spinner/Spinner";
import SnackBar from "components/SnackBar/SnackBar";
import Checkbox from "@mui/material/Checkbox";
import applicationUsageLog from "../../../utils/applicationUsagesLog";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import { Typography } from "@mui/material";
import { red } from "@mui/material/colors";
const typographyStyle = {
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  letterSpacing: "0.10rem",
  fontWeight: "bold",
  color: "#3F5765",
  marginTop: 1,
};
const SearchEmployee = () => {
  const [expandedPanel1, setExpandedPanel1] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const searchTypeOptions = ["Oracle Id / Ext EmployeeID", "Name"];
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [oracleIdEmpId, setOracleIdEmpId] = React.useState("");
  const [searchType, setSearchType] = React.useState(
    "Oracle Id / Ext EmployeeID",
  );
  const [isActive, setIsActive] = React.useState(true);
  const [jobNamesArray, setJobNamesArray] = React.useState([]);
  const [parentClientArray, setParentClientArray] = React.useState([]);
  const [clientArray, setClientArray] = React.useState([]);
  const [programArray, setProgramArray] = React.useState([]);
  const [projectArray, setProjectArray] = React.useState([]);
  const [jobName, setJobName] = React.useState({ JobTitle: "" });
  const [loader, setLoader] = React.useState(false);
  const [locationsArray, setLocationArray] = React.useState([]);
  const [logonIdArray, setLoginIdArray] = React.useState([]);
  const [loginId, setLoginId] = React.useState({ LoginId: "" });
  const [subSystemsArray, setSubSystemsArray] = React.useState([]);
  const [location, setLocation] = React.useState({ LocationName: "" });
  const [subSystem, setSubSystem] = React.useState({
    Name: "",
    CP_SubSystemId: "",
  });
  const [parentClient, setParentClient] = React.useState({
    ParentClientName: "",
  });
  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  const [client, setClient] = React.useState({
    ClientName: "",
    ClientCode: "",
  });
  const [program, setProgram] = React.useState({
    ProgramName: "",
    ProgramCode: "",
  });
  const [project, setProject] = React.useState({
    ProjectName: "",
    ProjectCode: "",
  });
  const [rows, setRows] = React.useState([]);

  const fetchData = async () => {
    setLoader(true);
    try {
      const jobResponse = await getAllJobNames();
      if (jobResponse?.data?.message === "Success") {
        setJobNamesArray(jobResponse?.data?.data);
      } else {
        errorHandler(true, "Job Names could not be fetched.", "error");
      }

      const locationResponse = await getAllLocations();
      if (locationResponse?.data?.message === "Success") {
        setLocationArray(locationResponse?.data?.data);
      } else {
        errorHandler(true, "Locations could not be fetched.", "error");
      }

      const parentClientResponse = await getParentClientDetails();
      if (parentClientResponse?.data?.message === "Success") {
        setParentClientArray(parentClientResponse?.data?.data);
      } else {
        errorHandler(true, "Parent clients could not be fetched.", "error");
      }

      const subSystemsResponse = await getAllSubSystems();
      if (subSystemsResponse?.data?.message === "Success") {
        setSubSystemsArray(subSystemsResponse?.data?.data);
      } else {
        errorHandler(true, "Sub systems could not be fetched.", "error");
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }
    setLoader(false);
  };

  const errorHandler = (open, message, severity) => {
    setSnack({
      open: true,
      message: message,
      severity: severity,
    });
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleParentClientChange = async (event, value) => {
    setLoader(true);
    setParentClient(value);
    setClient({
      ClientName: "",
      ClientCode: "",
    });

    setProgram({
      ProgramName: "",
      ProgramCode: "",
    });
    setProject({
      ProjectName: "",
      ProjectCode: "",
    });
    try {
      if (value !== null) {
        const clientResponse = await getClientDetails(value?.ParentClientId);
        if (clientResponse?.data?.message === "Success") {
          setClientArray(clientResponse?.data?.data);
          setProgramArray([]);
          setProjectArray([]);
        } else errorHandler(true, "Clients could not be fetched.", "error");
      } else {
        setClientArray([]);
        setProgramArray([]);
        setProjectArray([]);
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }
    setLoader(false);
  };

  const handleClientChange = async (event, value) => {
    setLoader(true);
    setClient(value);
    setProject({
      ProjectName: "",
      ProjectCode: "",
    });
    setProgram({
      ProgramName: "",
      ProgramCode: "",
    });
    try {
      if (value !== null) {
        const programResponse = await getProgramDetails(
          parentClient.ParentClientId,
          value?.ClientId,
        );
        if (programResponse?.data?.message === "Success") {
          setProgramArray(programResponse?.data?.data);
          setProjectArray([]);
        } else errorHandler(true, "Programs could not be fetched.", "error");
      } else {
        setProgramArray([]);
        setProjectArray([]);
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }
    setLoader(false);
  };

  const handleProgramChange = async (event, value) => {
    setLoader(true);
    setProgram(value);
    setProject({
      ProjectName: "",
      ProjectCode: "",
    });
    try {
      if (value !== null) {
        const projectResponse = await getProjectDetails(
          parentClient?.ParentClientId,
          client?.ClientId,
          value?.ProgramId,
        );
        if (projectResponse?.data?.message === "Success")
          setProjectArray(projectResponse?.data?.data);
        else errorHandler(true, "Projects could not be fetched.", "error");
        setLoader(false);
      } else {
        setProjectArray([]);
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }
    setLoader(false);
  };

  const handleSubSystemChange = async (event, value) => {
    setLoader(true);
    setSubSystem(value);
    try {
      if (value !== null) {
        const logonIdResponse = await getLogonIds(value?.CP_SubSystemId);
        if (logonIdResponse?.data?.message === "Success") {
          setLoginIdArray(logonIdResponse?.data?.data);
          setLoginId({ LoginId: "" });
        } else errorHandler(true, "Logon Ids could not be fetched.", "error");
      } else {
        setLoginIdArray([]);
        setLoginId({ LoginId: "" });
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }
    setLoader(false);
  };

  const handleReset = () => {
    setError(false);
    setIsActive(true);
    setOracleIdEmpId("");
    setFirstName("");
    setLastName("");
    setSearchType("Oracle Id / Ext EmployeeID");
    setJobName({ JobTitle: "" });
    setLoginIdArray([]);
    setLoginId({ LoginId: "" });
    setLocation({ LocationName: "" });
    setSubSystem({
      Name: "",
      CP_SubSystemId: "",
    });
    setParentClient({
      ParentClientName: "",
    });
    setClient({
      ClientName: "",
      ClientCode: "",
    });
    setProgram({
      ProgramName: "",
      ProgramCode: "",
    });
    setProject({
      ProjectName: "",
      ProjectCode: "",
    });
    setRows([]);
  };

  const handleSearch = async () => {
    setLoader(true);

    if (searchType === "Name" && firstName.length < 3 && lastName.length < 3) {
      setError(true);
      setErrorMessage("Please enter at least 3 characters for the name");
    } else {
      setError(false);
      const payload = {
        searchType:
          searchType?.replace(/\s/g, "") === "OracleId/ExtEmployeeID"
            ? "OracleId"
            : "Name",
        oracleOrExtEmpId: oracleIdEmpId,
        firstName: firstName,
        lastName: lastName,
        parentClientId: parentClient?.ParentClientId || 0,
        clientId: client?.ClientId || 0,
        programId: program?.ProgramId || 0,
        projectId: project?.ProjectId || 0,
        locationName: location?.LocationName,
        subsystemId: subSystem?.CP_SubSystemId || 0,
        logOnId: loginId?.LoginId,
        jobName: jobName?.JobTitle,
        isActive: isActive,
      };

      const response = await searchEmployees(payload);

      if (response?.data?.message === "Success") {
        setRows(response?.data?.data);
        setExpandedPanel1(false);
      } else {
        setRows([]);
        errorHandler(true, "No results found.", "info");
      }
    }

    setLoader(false);
  };

  React.useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      try {
        await fetchData();

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "CenterPoint",
            "Search Employee",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      {loader ? <BackdropComponent /> : null}

      <div>
        <Accordion
          expanded={expandedPanel1}
          onChange={() => setExpandedPanel1((prev) => !prev)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className={classes.headingContainer}>
              <span className={classes.filterText}> Search Employee</span>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className={classes.gridContainer}>
              <Grid item xs={1.5}>
                <Typography sx={typographyStyle}>Search Type :</Typography>
              </Grid>
              <Grid item xs={4.5}>
                <select
                  className={classes.cpDropdown}
                  placeholder="Search Type"
                  value={searchType}
                  onChange={(e) => {
                    setSearchType(e.target.value);
                    setError(false);
                    if (e.target.value === "Oracle Id / Ext EmployeeID") {
                      setFirstName("");
                      setLastName("");
                    } else setOracleIdEmpId("");
                  }}
                >
                  {searchTypeOptions.map((values, index) => (
                    <option key={values} value={values}>
                      {values}
                    </option>
                  ))}
                </select>
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={{ ...typographyStyle, paddingLeft: 1 }}>
                  Parent Client :
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={parentClientArray}
                  value={parentClient}
                  className={classes.rightAutoFieldWidth}
                  onChange={handleParentClientChange}
                  getOptionLabel={(option) =>
                    option?.ParentClientName === ""
                      ? ""
                      : `${
                          option?.ParentClientName +
                          " (" +
                          option?.ParentClientCode +
                          ")"
                        }`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5} className={classes.marginTop}></Grid>
              <Grid item xs={4.5}>
                {}{" "}
                {searchType === "Name" ? (
                  <div className={classes.name}>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      label="LAST NAME"
                      className={classes.searchField}
                      multiline
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      rows={1}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                    />

                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      label="FIRST NAME"
                      className={classes.searchField}
                      multiline
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      rows={1}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                    />
                  </div>
                ) : (
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    label="Oracle Id / Ext EmployeeID"
                    className={classes.searchField}
                    size="small"
                    multiline
                    value={oracleIdEmpId}
                    onChange={(e) => setOracleIdEmpId(e.target.value)}
                    rows={1}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.preventDefault();
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={{ ...typographyStyle, paddingLeft: 1 }}>
                  Client :
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={clientArray}
                  value={client}
                  onChange={handleClientChange}
                  className={classes.rightAutoFieldWidth}
                  getOptionLabel={(option) =>
                    option?.ClientName === "" && option?.ClientCode === ""
                      ? ""
                      : `${
                          option?.ClientName + " (" + option?.ClientCode + ")"
                        }`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={typographyStyle}> Sub System :</Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={subSystemsArray}
                  value={subSystem}
                  className={classes.searchField}
                  onChange={handleSubSystemChange}
                  getOptionLabel={(option) =>
                    option?.Name === "" && option?.CP_SubSystemId === ""
                      ? ""
                      : `${option?.Name + " (" + option?.CP_SubSystemId + ")"}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={{ ...typographyStyle, paddingLeft: 1 }}>
                  {" "}
                  Program :
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={programArray}
                  value={program}
                  className={classes.rightAutoFieldWidth}
                  onChange={handleProgramChange}
                  getOptionLabel={(option) =>
                    option.ProgramName === "" && option.ProgramCode === ""
                      ? ""
                      : `${
                          option?.ProgramName + " (" + option?.ProgramCode + ")"
                        }`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5} className={classes.marginTop}>
                <Typography sx={typographyStyle}>Logon Id :</Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={logonIdArray}
                  value={loginId}
                  className={classes.searchField}
                  onChange={(e, inputValue) => setLoginId(inputValue)}
                  getOptionLabel={(option) =>
                    option?.LoginId === "" ? "" : `${option?.LoginId}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={{ ...typographyStyle, paddingLeft: 1 }}>
                  {" "}
                  Project :
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={projectArray}
                  value={project}
                  className={classes.rightAutoFieldWidth}
                  onChange={(e, inputValue) => setProject(inputValue)}
                  getOptionLabel={(option) =>
                    option?.ProjectName === "" && option?.ProjectCode === ""
                      ? ""
                      : `${
                          option?.ProjectName + " (" + option?.ProjectCode + ")"
                        }`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={typographyStyle}>Location Name/ID :</Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={locationsArray}
                  value={location}
                  className={classes.searchField}
                  onChange={(e, value) => setLocation(value)}
                  getOptionLabel={(option) =>
                    option?.LocationName === ""
                      ? ""
                      : `${
                          option?.LocationName + " (" + option?.GeoLocCd + ")"
                        }`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                {" "}
                <Typography sx={{ ...typographyStyle, paddingLeft: 1 }}>
                  Active Records Only ?
                </Typography>
              </Grid>
              <Grid item xs={4.5}>
                {" "}
                <Checkbox
                  className={classes.checkBoxText}
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={typographyStyle}> Job Name :</Typography>
              </Grid>
              <Grid item xs={4.5}>
                <Autocomplete
                  disablePortal
                  blurOnSelect
                  options={jobNamesArray}
                  value={jobName}
                  className={classes.searchField}
                  onChange={(e, value) => setJobName(value)}
                  getOptionLabel={(option) =>
                    option?.JobTitle === "" ? "" : `${option?.JobTitle}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} size="small" />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}></Grid>
              <Grid item xs={1} className={classes.marginTop}>
                <CustomButton
                  sx={{ backgroundColor: "#3299FF" }}
                  variant="contained"
                  onClick={handleSearch}
                >
                  Search
                </CustomButton>
              </Grid>
              <Grid item xs={1}>
                <CustomButton
                  sx={{ color: "#3299FF" }}
                  variant="outlined"
                  onClick={handleReset}
                >
                  Reset
                </CustomButton>
              </Grid>
              <Grid item xs={8.5}></Grid>
            </Grid>
            {error && (
              <Typography
                sx={{
                  ...typographyStyle,
                  fontWeight: "none",
                  color: red[700],
                  textAlign: "center",
                }}
              >
                {errorMessage}
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
        <hr />
        {rows?.length > 0 && <SearchResults rows={rows} />}

        <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      </div>
    </>
  );
};

export default SearchEmployee;
